import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { Modal } from 'react-bootstrap'

const AUTOCOMPLETE_POPPER_SLOT_PROPS = {
  placement: 'bottom-start',
  modifiers: [
    {
      name: 'flip',
      enabled: false
    }
  ],
  sx: {
    zIndex: 1400
  }
}

const ReassignUserModal = ({
  show = false,
  description = 'Reasignar un usuario para transferirle todas las marcas del usuario escogido.',
  currentUser = null,
  nextUser = null,
  nextUserOptions = [],
  nextUserSearch = '',
  loading = false,
  confirming = false,
  confirmLabel = 'Confirmar y asignar',
  onClose,
  onConfirm,
  onNextUserChange,
  onNextUserSearchChange
}) => {
  return (
    <Modal
      centered
      show={show}
      onHide={confirming ? undefined : onClose}
      dialogClassName="store-relations-reassign-modal"
    >
      <Modal.Header closeButton={!confirming} className="store-relations-reassign-modal__header">
        <Modal.Title className="store-relations-reassign-modal__title">
          Reasignar usuario
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="store-relations-reassign-modal__body">
        <p className="store-relations-reassign-modal__description">
          {description}
        </p>

        <div className="store-relations-reassign-modal__section">

          <div className="store-relations-reassign-modal__field">
            <label className="store-relations-reassign-modal__label">
              Usuario actual:
            </label>

            <Autocomplete
              disabled
              fullWidth
              value={currentUser}
              options={currentUser ? [currentUser] : []}
              getOptionLabel={(option) => option?.label || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Usuario actual"
                />
              )}
            />
          </div>

          <div className="store-relations-reassign-modal__field">
            <label className="store-relations-reassign-modal__label">
              Reasignar Usuario:
            </label>

            <Autocomplete
              disabled={confirming}
              fullWidth
              slotProps={{ popper: AUTOCOMPLETE_POPPER_SLOT_PROPS }}
              options={nextUserOptions}
              loading={loading}
              value={nextUser}
              inputValue={nextUserSearch}
              getOptionLabel={(option) => option?.label || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(_, value) => onNextUserChange?.(value)}
              onInputChange={(_, value, reason) => {
                if (reason === 'reset') return
                onNextUserSearchChange?.(value)
              }}
              noOptionsText="No hay resultados"
              loadingText="Cargando usuarios..."
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Escoja o busque un usuario"
                />
              )}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="store-relations-reassign-modal__footer">
        <button
          type="button"
          className="store-relations-reassign-modal__btn store-relations-reassign-modal__btn--secondary"
          onClick={onClose}
          disabled={confirming}
        >
          Cancelar
        </button>

        <button
          type="button"
          className="store-relations-reassign-modal__btn store-relations-reassign-modal__btn--primary"
          onClick={onConfirm}
          disabled={!nextUser?.db_ref || confirming}
        >
          {confirming ? 'Reasignando...' : confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReassignUserModal
